import { t } from 'i18next';
import * as yup from 'yup';

export const updateJobNameSchema = () =>
  yup.object().shape({
    jobName: yup.string().nullable().label(t('labelJobName')).required(),
  });
